// Permisos del equipo por comunidad. Vienen en `status.staff`: una entrada por
// comunidad con sus roles y la unión de sus permisos (catálogo en
// api/config/permissions.php). El backend valida todo; aquí solo se decide qué
// se muestra.

export type StaffCommunity = {
  uuid: string;
  name: string;
  settings?: Record<string, any>;
  features?: Record<string, any>;
  roles: { name: string; display_name: string }[];
  permissions: string[];
  [key: string]: any;
};

/** Tiene alguno de los permisos. */
export function can(community: StaffCommunity | undefined | null, ...permissions: string[]): boolean {
  const granted = community?.permissions ?? [];
  return permissions.some(permission => granted.includes(permission));
}

/** Entra al panel de administración. */
export function hasAdminPanel(community: StaffCommunity | undefined | null): boolean {
  return can(community, 'admin_panel.access');
}

/** Tiene alguno de los roles. */
export function hasRole(community: StaffCommunity | undefined | null, ...roles: string[]): boolean {
  return (community?.roles ?? []).some(role => roles.includes(role.name));
}

/**
 * Usa la consola de vigilancia: el permiso y además el rol `security`. Owner y
 * admin traen `guard.console` por el `*`, pero no son vigilantes.
 */
export function hasGuardConsole(community: StaffCommunity | undefined | null): boolean {
  return can(community, 'guard.console') && hasRole(community, 'security');
}
